import { ICurrency } from '../apis/common';

// Compare to makePrice() used in the frontend repo.
export const formatPrice = (currency: ICurrency, cents: number): string => {
  const format = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency.code });
  return format.format(cents / currency.unitsPerSymbol);
}
